import './DeathNotificationMainLayout.scss';
import React, { useEffect, useState } from 'react';

import { getContentFragments } from 'utils/Content-Fragment-Utils';
import DeathNotificationBody from 'components/layouts/DeathNotification/DeathNotificationBody/DeathNotificationBody';
import StepFooter from 'components/shared/StepFooter/StepFooter';
import { connect } from 'react-redux';
import { listSteps } from 'utils/LayoutUtils';
import {
  getCurrentStep,
  getShowBack,
} from 'state/steps/StepSelectors';

import SessionTimer from 'components/layouts/SessionTimer/SessionTimer';
import {
  getContentFragmentError,
  getHasReceivedContentFragments
} from 'state/contentFragments/ContentFragmentSelectors';
import LoadingSpinner from 'components/layouts/LoadingSpinner/LoadingSpinner';

const DeathNotificationMainLayout = ({
  currentStep,
  hasShowBack,
  hasReceivedContentFragments,
  contentFragmentError
}) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getContentFragments();
  }, []);

  useEffect(() => {
    if(hasReceivedContentFragments) {
      setIsLoading(false);
    }

    return () => setIsLoading(false);
  }, [hasReceivedContentFragments])

  useEffect(() => {
    if(contentFragmentError) {
      setIsLoading(false);
    }
  }, [contentFragmentError])

  const { continueButtonText, backButtonText, onBackClickURL, onContinueClickURL, onClickFunction, openParent, showFooter } = listSteps[currentStep];

  if(isLoading) {
    return <LoadingSpinner name="Notification of Death..."/>
  }

  return (
    <div>
      <SessionTimer />
      <DeathNotificationBody/>
      {showFooter &&
        <StepFooter continueButtonText={continueButtonText}
                    backButtonText={backButtonText}
                    onBackClickURL={onBackClickURL}
                    onContinueClickURL={onContinueClickURL}
                    showBackButton={hasShowBack}
                    openParent={openParent}
                    onClickFunction={onClickFunction}/>
      }
    </div>
  );
};


const mapStateToProps = state => ({
  currentStep: getCurrentStep(state),
  hasShowBack: getShowBack(state),
  hasReceivedContentFragments: getHasReceivedContentFragments(state),
  contentFragmentError: getContentFragmentError(state)
});
export default connect(mapStateToProps)(DeathNotificationMainLayout);